import {
    getIncidents
} from '../../../queries/map-incidents';

import Graphic from "@arcgis/core/Graphic.js";

import {
    popupTemplate
} from '../../../queries/popup-templates/incident-popup-template';

/**
 * Toggles the map incidents on or off depending on the `toggleOn` variable.
 * 
 * For some reason, the `.removeAll()` function does NOT work when the esriMapView
 * is passed as a reference to this function.
 * 
 * @param {*} toggleOn 
 * @param {*} esriMapView The map view these changes are to be made to
 */
export function addMapIncidents(graphicsLayer) {

    const graphicsCallback = (newSymbol, geometryPoint, attributes) => {
        graphicsLayer.graphics.add(new Graphic({
            symbol: newSymbol,
            geometry: geometryPoint,
            popupTemplate: popupTemplate,
            attributes: attributes
        }));
    }

    getIncidents(graphicsCallback);
    
}